import { HttpErrorResponse } from '@angular/common/http';

/**
 * The CRM catalog endpoints answer with 403 `{"errors":[{"code":403,"message":"Your tariff plan was expired."}]}`
 * when the user tariff plan is no longer active — no other case returns 403 there.
 */
export const isTariffExpiredError = (error: unknown): boolean =>
    error instanceof HttpErrorResponse && error.status === 403;
